import { CompanyErrorBody } from '@/api/pc-api/v1/company';
import { ServerActionPopupErrorStatus } from '@/constants/error/serverErrorStatus';
import HttpStatusError from '@/utils/error/HttpStatusError';

export type ServerActionPopupErrorBody =
  | {
      status: Exclude<ServerActionPopupErrorStatus, ServerActionPopupErrorStatus.NOT_FULL_INFO_COMPANY>;
      message: string;
    }
  | { status: ServerActionPopupErrorStatus.NOT_FULL_INFO_COMPANY; message: string; data: CompanyErrorBody };

class ServerActionPopupError extends HttpStatusError {
  status: number;
  data?: CompanyErrorBody;

  constructor(args: ServerActionPopupErrorBody) {
    super(args.message);
    this.status = args.status;

    if (args.status === ServerActionPopupErrorStatus.NOT_FULL_INFO_COMPANY) {
      this.data = args.data;
    }
  }
}

export default ServerActionPopupError;
